import SingleLegBet from './SingleLegBet';

class Trifecta extends SingleLegBet {
	static title () { return 'Trifecta'; }
	static positions() {
		return 3;
	}
}

export default Trifecta;



/** WEBPACK FOOTER **
 ** ./site/sites/all/themes/custom/abr_theme/js/gambling-calculator/bets/SingleLeg/Trifecta.js
 **/